<template>
  <app-layout>
    <nav class="relative z-0 rounded-lg shadow flex divide-x divide-gray-200 mb-6" aria-label="Tabs">
      <inertia-link v-for="(item, idx) in nav" :key="`databaseNav${idx}`"
        :href="route(item.route)"
        :class="[`${route().current(item.routeGroup || item.route) ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}`, `${idx === 0 ? 'rounded-l-lg' : ''}`, `${idx === nav.length - 1 ? 'rounded-r-lg' : ''}`, 'capitalize group relative min-w-0 flex-1 flex flex-col justify-center overflow-hidden bg-white py-4 px-4 text-xs font-medium text-center lg:text-sm hover:bg-gray-50 focus:z-10']">
        {{ item.name }}
        <span aria-hidden="true"
          :class="[`${route().current(item.routeGroup || item.route) ? 'bg-indigo-500' : 'bg-transparent'}`, 'absolute inset-x-0 bottom-0 h-0.5']"></span>
      </inertia-link>
    </nav>
    <div class="flex w-full gap-4 relative items-start">
      <nav v-if="steps" class="flex-none h-auto w-60 2xl:w-96 sticky top-1">
        <ul role="list" class="py-6 pl-10 pr-2 space-y-1">
          <li>
            <!-- Current: "bg-gray-100 text-indigo-600", Default: "text-gray-700 hover:text-indigo-600 hover:bg-gray-100" -->
            <inertia-link :href="route('cms.database.sync.index')" :class="`group flex gap-x-3 rounded-md  p-2 text-sm/6 font-semibold ${ route().current('cms.database.sync.index') ? 'bg-gray-200 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-200'}`">
              Start
            </inertia-link>
          </li>
          <li v-for="step in steps" :key="`dbSyncStep${step.value}`" :ref="`step-${step.value}`">
            <inertia-link :href="route('cms.database.sync.step', {step: step.value})" :class="`group flex gap-x-3 rounded-md  p-2 text-sm/6 font-semibold ${ route().current('cms.database.sync.step', {step: step.value}) ? 'bg-gray-200 text-indigo-600' : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-200'}`">
              {{ step.label }}
            </inertia-link>
            <ul v-if="step.children" class="h-96 p-4 mt-2 space-y-1 overflow-x-hidden overflow-y-auto rounded-lg bg-gray-300" :ref="`step-${step.value}-children`">
              <li v-for="child in step.children" class="w-full" :data-child-name="child.name" :ref="`step-${step.value}-child-${child.id}`">
                <inertia-link :title="child.name" :href="route('cms.database.sync.step', {step: step.value, child: child.id})" :class="`block group w-full h-10 relative overflow-hidden rounded-md p-2 text-sm/6 font-semibold ${ route().current('cms.database.sync.step', {step: step.value, child: child.id}) ? 'bg-gray-800 text-indigo-100' : 'text-gray-800 hover:text-indigo-100 hover:bg-gray-800'}`">
                  <span class="block absolute w-fit h-10 p-2 min-w-full whitespace-nowrap top-1/2 transform -translate-y-1/2 left-0 translate-x-0 ease-in-out transition-transform duration-1000  group-hover:translate-x-[calc(160px-100%)] 2xl:group-hover:translate-x-[calc(304px-100%)]">{{ child.name }}</span>
                </inertia-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <base-card class="w-[calc(100%-256px)] 2xl:w-[calc(100%-400px)] max-w-full flex-1">
        <slot />
      </base-card>
    </div>
  </app-layout>
</template>
<script>
export default {
  name: 'DatabaseLayout',
  data() {
    return {
      nav: [
        {
          name: 'Dashboard',
          route: 'cms.database.index',
        },
        {
          name: 'Export',
          route: 'cms.database.export',
        },
        {
          name: 'Import',
          route: 'cms.database.import',
        },
        {
          name: 'Sync',
          route: 'cms.database.sync.index',
          routeGroup: 'cms.database.sync.*',
        },
      ],
    }
  },
  computed: {
    steps() {
      return this.$page.props.steps
    }
  },
  mounted() {
    const stepName = this.$page.props.step || null;
    const childName = this.$page.props.child || null;
    if (stepName && childName) {
      const step = this.steps.find(s => s.label == stepName);
      if (step && step.children) {
        const child = step.children.find(c => c.name == childName);
        if (child) {
          const childRef = this.$refs[`step-${step.value}-child-${child.id}`];
          if (childRef) {
            const childParentElement = childRef[0].parentElement;
            if (childParentElement) {
              childParentElement.scrollTop = childRef[0].offsetTop - childParentElement.offsetTop - 20;
            } else {
              console.error(`Connot find parent element for ${childName}`);
            }
          } else {
            console.error(`Cannot find child ref for ${childName}`);
          }

          //$vm0.$refs['step-modules-child-4'][0].parentElement.scrollTop = ($vm0.$refs['step-modules-child-4'][0].offsetTop -  $vm0.$refs['step-modules-child-4'][0].parentElement.offsetTop)

        } else {
          console.error(`Cannot find child ${childName}`);
        }
      } else {
        console.error(`Cannot find step ${stepName}`);
      }
    }
  }
}
</script>
